export default __webpack_public_path__ + "static/media/powerOpen.ebf712ac.png";